import { useDispatch } from "react-redux";
import { updateLikeBtnServer } from "../../features/post/postSlice";


export default function Like({postId, likes}) {
  const dispatch = useDispatch();
    const handleLike = ()=>{
        dispatch(updateLikeBtnServer({postId, likes}))
    }
  return (
    <button onClick={handleLike} className="like-btn" id="lws-singleLinks">
      <i className="fa-regular fa-thumbs-up"></i> {likes}
    </button>
  );
}
